'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var semanticTokens = {
  colors: {
    'body-text': 'gray.500',
    'body-bg': 'white',
    'placeholder-color': 'gray.300'
  }
};
exports.semanticTokens = semanticTokens;